module.exports = __webpack_public_path__ + "static/media/KohinoorBangla-Semibold.97777410.svg";